import "./scroll-tile.scss";

import React from "react";
import classNames from "classnames";

const ScrollTile = ({
  icon,
  title,
  description,
  anchor,
  buttonText,
  link,
  shadow,
  contact,
}) => {
  return (
    <a href={anchor ? `#${anchor}` : link}>
      <div
        className={classNames("scroll-tile", {
          [`scroll-tile scroll-tile--no-shadow`]: shadow === false,
          [`scroll-tile scroll-tile--contact-tile`]: contact === true,
        })}
      >
        <div className="scroll-tile__icon-container">
          <img src={icon} alt="" className="scroll-tile__icon" />
        </div>
        <div
          className="scroll-tile__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className="scroll-tile__desc">{description}</div>
        <div className="scroll-tile__button btn btn--text">{buttonText}</div>
      </div>
    </a>
  );
};

export default ScrollTile;
